const isRecord = (value: unknown): value is Record<string, unknown> => (
    typeof value === 'object'
    && value !== null
    && !(value instanceof FormData)
    && !(value instanceof URLSearchParams)
    && !(value instanceof HTMLFormElement)
    && !(value instanceof Blob)
    && !(value instanceof ArrayBuffer)
);

const cloneSerializable = <T>(value: T): T => structuredClone(value);

const isSerializableEqual = (left: unknown, right: unknown): boolean => {
    if (Object.is(left, right)) return true;
    if (Array.isArray(left) || Array.isArray(right)) {
        return Array.isArray(left)
            && Array.isArray(right)
            && left.length === right.length
            && left.every((value, index) => isSerializableEqual(value, right[index]));
    }
    if (!isRecord(left) || !isRecord(right)) return false;
    const leftKeys = Object.keys(left);
    const rightKeys = Object.keys(right);
    return leftKeys.length === rightKeys.length
        && leftKeys.every((key) => Object.hasOwn(right, key) && isSerializableEqual(left[key], right[key]));
};

const isPromiseLike = (value: unknown): value is PromiseLike<unknown> => (
    value !== null
    && (typeof value === 'object' || typeof value === 'function')
    && 'then' in value
    && typeof value.then === 'function'
);

export {cloneSerializable, isPromiseLike, isRecord, isSerializableEqual};
